export default {
  methods: {
    async handleChatbotFlowOnNewConversation(
      campaignId = null,
      triggerType = 'widget',
      createConversation = false,
      contactData = null,
    ) {
      if (!this.hasAConnectedAgentBot) return;
      
      if (createConversation) {
        this.$store.dispatch('conversation/createConversation', {}).then((resp) => {
            this.registerChatsbotService({
              conversationId: resp.id,
              inboxId: resp.inbox_id,
              triggerType,
              nudgeId: campaignId
            });
          });
          return;
      }

      await this.sendMessage({
        content: ''
      }).then(resp => {
        const { conversation_id, inbox_id } = resp.data;
        if (contactData) {
            this.$store.dispatch('contacts/update', { user: {...contactData}});
        }
        this.registerChatsbotService({
          conversationId: conversation_id,
          inboxId: inbox_id,
          triggerType,
          nudgeId: campaignId
        });
      });
    }
  }
};
